import ApiService from "../infra/ApiService";
import TableNotes from "../utils/TableNotes";

const actions = {
  setSelectedDataFromSped({ commit }, selectedDataFromSped) {
    const table = new TableNotes();
    const data = table.spedNotes(selectedDataFromSped);
    commit("SET_SELECTED_DATA_FROM_SPED", data);
  },
  setExpandedNote({ commit }, note) {
    commit("SET_EXPANDED_NOTE", note);
  },
  setSeletedItensFromXML({ commit }, seletedItensFromXML) {
    commit("SET_ITENS_FROM_XML", seletedItensFromXML);
  },
  setIsReferencing({ commit }, { idNfe, xProd, cProd }) {
    commit("SET_ITEM_TO_REFERENCING", { idNfe, xProd, cProd });
  },
  setItemXMLReference({ commit }, productInfo) {
    commit("REMOVE_REFERENCE", productInfo);
  },
  async removeReference(
    { commit, getters, dispatch, rootGetters },
    { idNfe, idItem, xProd },
    messages,
  ) {
    commit("SET_NOTE_TO_CALCULATING", { idNfe, xProd });
    const apiService = new ApiService(messages);
    const itensToRemoveReference = getters
      .getReferencedItems(idNfe)
      .filter((item) => item.xProd === xProd);
    await Promise.all(
      itensToRemoveReference.map(async (item) =>
        apiService.deleteReference({
          ...item,
          idEmpresa: rootGetters.getCompany.id,
        }),
      ),
    );
    const isDuplicatedItems = itensToRemoveReference.every(
      (item, idx, self) => item.cProd === self[0].cProd && self.length > 1,
    );
    if (isDuplicatedItems)
      commit("REMOVE_REFERENCE", {
        idNfe,
        xProd,
        cProd: itensToRemoveReference[0].cProd,
      });
    else
      itensToRemoveReference.forEach((item) =>
        commit("REMOVE_REFERENCE", { idNfe, xProd, cProd: item.cProd }),
      );
    commit("SET_VL_APURATION_ON_NF", {
      idNfe,
      totalNote: getters.getTotalApuredByNote(idNfe),
    });
    await Promise.all(
      itensToRemoveReference.map(async (item) =>
        apiService.resetVlIcmsItem({ idNfe: item.idNfe, idItem: item.idItem }),
      ),
    );
    commit("SET_NOTE_TO_CALCULATING", { idNfe, xProd });
  },
  async calculateDifAliq(
    { commit, getters, dispatch },
    { vlIcms, ...note },
    messages,
  ) {
    commit("SET_NOTE_TO_CALCULATING", { idNfe: note.idNfe, xProd: note.xProd });
    const apiService = new ApiService(messages);
    const hasItemNoCalculated = getters.getReferencedItems(note.idNfe);
    const apuration = await Promise.all(
      hasItemNoCalculated.map(async (item) =>
        apiService.getCalc({ ...item, ...note }),
      ),
    );
    commit("SET_VL_APURATION_ON_ITEMS", { idNfe: note.idNfe, apuration });
    commit("SET_VL_APURATION_ON_NF", {
      idNfe: note.idNfe,
      totalNote: getters.getTotalApuredByNote(note.idNfe),
    });
    await dispatch("saveIcmsValue", { idNfe: note.idNfe, messages });
    commit("SET_NOTE_TO_CALCULATING", { idNfe: note.idNfe, xProd: note.xProd });
    commit("SET_TOTAL_APURATION", { idNfe: note.idNfe, apuration });
  },
  setSelectedNote({ commit }, note) {
    commit("SET_SELECTED_NOTE", note);
  },
  async saveIcmsValue({ getters, rootGetters }, { idNfe, messages }) {
    const [{ cpfCnpj, nNf, ser, codMod }] = getters.getNoteById(idNfe);
    const { vDifal } = getters.getTotalApuredByNote(idNfe);
    const value = {
      idEmpresa: rootGetters.getCompany.id,
      cpfCnpj,
      numDoc: nNf,
      ser,
      codMod,
      vlIcmsDar: vDifal,
      vlPobreza: 0,
    };
    const apiService = new ApiService(messages);
    await apiService.insertStApured(value);
  },
  getKeys({ commit }) {
    commit("GET_KEYS");
  },
  setKeys({ commit }, keys) {
    commit("SET_KEYS", keys);
  },
};

export default actions;
